export default __webpack_public_path__ + "static/media/no_image_found.1d37c246.png";